var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.75,
    height: 11.188,
    viewBox: "0 0 6.75 11.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Text_Body_2_Selected_On_Surface_Medium_Emphasis_Left_",
    "data-name": "\\u2731 / Text / Body 2 / Selected / On Surface / Medium Emphasis / Left ",
    d: "M-.33-12.045l4.5,4.468a1.225,1.225,0,0,1,.33.795,1.177,1.177,0,0,1-.33.8L-.33-1.518a1.125,1.125,0,0,1-1.226.244A1.053,1.053,0,0,1-2.25-2.282V-11.25a1.125,1.125,0,0,1,.694-1.04,1.122,1.122,0,0,1,1.225.245Z",
    transform: "translate(2.25 12.375)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.f944aa8c9e947d094884f0f2dd6a8e4f.svg";
export { ForwardRef as ReactComponent };